module.exports = {
	devLogURL: location.protocol + '//s.anjuke.test/ts.html?',
    logURL: location.protocol + '//prism.anjuke.com/ts.html?',
    devSojURL: location.protocol + '//s.anjuke.test/stb'
}
